module.exports = __webpack_public_path__ + "static/media/ic_predict.560d7a93.svg";